/**
 * Sovereignty domain labels, SEAL colors, and SEAL level labels.
 * Used across UI components for consistent display of sovereignty scoring data.
 */

/** Descriptive labels for each SOV domain in German and English */
export const SOV_DOMAIN_LABELS: Record<string, { de: string; en: string }> = {
  "SOV-1": { de: "Rechtlicher & Institutioneller Rahmen", en: "Legal & Institutional Framework" },
  "SOV-2": { de: "Jurisdiktionelle Souveränität", en: "Jurisdictional Sovereignty" },
  "SOV-3": { de: "Daten- & KI-Souveränität", en: "Data & AI Sovereignty" },
  "SOV-4": { de: "Operationelle Souveränität", en: "Operational Sovereignty" },
  "SOV-5": { de: "Lieferketten-Souveränität", en: "Supply Chain Sovereignty" },
  "SOV-6": { de: "Technologische Souveränität", en: "Technological Sovereignty" },
  "SOV-7": { de: "Sicherheit & Compliance", en: "Security & Compliance" },
  "SOV-8": { de: "Ökologische Nachhaltigkeit", en: "Environmental Sustainability" },
};

/** Color mapping for SEAL levels 0–4 */
export const SEAL_COLORS: Record<number, string> = {
  0: "#DC2626",  // red
  1: "#F59E0B",  // amber
  2: "#3B82F6",  // blue
  3: "#10B981",  // emerald
  4: "#059669",  // dark green
};

/** SEAL level labels in German and English */
export const SEAL_LABELS: Record<number, { de: string; en: string }> = {
  0: { de: "Keine Souveränität", en: "No Sovereignty" },
  1: { de: "Jurisdiktionelle Souveränität", en: "Jurisdictional Sovereignty" },
  2: { de: "Datensouveränität", en: "Data Sovereignty" },
  3: { de: "Digitale Resilienz", en: "Digital Resilience" },
  4: { de: "Volle Digitale Souveränität", en: "Full Digital Sovereignty" },
};
